
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { BcDocumentType } from 'enums/BcDocumentType';
import { Model, ModelProperty } from 'models/Model';


export class DebtCollectionReadyInvoicesDtoModel extends Model<DebtCollectionReadyInvoicesDtoModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'ledgerHeaderId', type: 'guid', languageString: 'debtCollectionReadyInvoicesDto.property.ledgerHeaderId' },
		{ name: 'documentNo', type: 'string', languageString: 'debtCollectionReadyInvoicesDto.property.documentNo' },
		{ name: 'entryNo', type: 'number', languageString: 'debtCollectionReadyInvoicesDto.property.entryNo' },
		{ name: 'remainingAmountInclVat', type: 'number', languageString: 'debtCollectionReadyInvoicesDto.property.remainingAmountInclVat' },
		{ name: 'originalAmountInclVat', type: 'number', languageString: 'debtCollectionReadyInvoicesDto.property.originalAmountInclVat' },
		{ name: 'originalDueDate', type: 'Date', languageString: 'debtCollectionReadyInvoicesDto.property.originalDueDate' },
		{ name: 'customerNo', type: 'string', languageString: 'debtCollectionReadyInvoicesDto.property.customerNo' },
		{ name: 'companyId', type: 'guid', languageString: 'debtCollectionReadyInvoicesDto.property.companyId' },
		{ name: 'postingDate', type: 'Date', languageString: 'debtCollectionReadyInvoicesDto.property.postingDate' },
		{ name: 'documentType', type: 'BcDocumentType', languageString: 'debtCollectionReadyInvoicesDto.property.documentType' },
		{ name: 'dueDate', type: 'Date', languageString: 'debtCollectionReadyInvoicesDto.property.dueDate' },
		{ name: 'objectionReasonId', type: 'guid', languageString: 'debtCollectionReadyInvoicesDto.property.objectionReasonId' }
	];
	[key: string]: any;
	
	public ledgerHeaderId?: string;
	public documentNo: string;
	public entryNo: number;
	public remainingAmountInclVat?: number;
	public originalAmountInclVat?: number;
	public originalDueDate?: Date;
	public customerNo: string;
	public companyId?: string;
	public postingDate?: Date;
	public documentType: BcDocumentType;
	public dueDate?: Date;
	public objectionReasonId?: string;
    
	constructor(){
		super();
		this.ledgerHeaderId = undefined;
		this.documentNo = '';
		this.entryNo = 0;
		this.remainingAmountInclVat = undefined;
		this.originalAmountInclVat = undefined;
		this.originalDueDate = undefined;
		this.customerNo = '';
		this.companyId = undefined;
		this.postingDate = undefined;
		this.documentType = 0;
		this.dueDate = undefined;
		this.objectionReasonId = undefined;
		
	}
	getProperties(){
		return DebtCollectionReadyInvoicesDtoModel.classProperties;
	}
}
export class DebtCollectionDtoModel extends Model<DebtCollectionDtoModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'companyName', type: 'string', languageString: 'debtCollectionDto.property.companyName' },
		{ name: 'vatNumber', type: 'string', languageString: 'debtCollectionDto.property.vatNumber' },
		{ name: 'address', type: 'string', languageString: 'debtCollectionDto.property.address' },
		{ name: 'city', type: 'string', languageString: 'debtCollectionDto.property.city' },
		{ name: 'contact', type: 'string', languageString: 'debtCollectionDto.property.contact' },
		{ name: 'zipcode', type: 'string', languageString: 'debtCollectionDto.property.zipcode' },
		{ name: 'emailAddress', type: 'string', languageString: 'debtCollectionDto.property.emailAddress' },
		{ name: 'businessStatus', type: 'string', languageString: 'debtCollectionDto.property.businessStatus' },
		{ name: 'count', type: 'number', languageString: 'debtCollectionDto.property.count' },
		{ name: 'objectionReasonName', type: 'string', languageString: 'debtCollectionDto.property.objectionReasonName' },
		{ name: 'inDebtCollection', type: 'boolean', languageString: 'debtCollectionDto.property.inDebtCollection' }
	];
	[key: string]: any;
	
	public companyName: string;
	public vatNumber: string;
	public address: string;
	public city: string;
	public contact: string;
	public zipcode: string;
	public emailAddress: string;
	public businessStatus: string;
	public count: number;
	public objectionReasonName: string;
	public inDebtCollection: boolean;
    
	constructor(){
		super();
		this.companyName = '';
		this.vatNumber = '';
		this.address = '';
		this.city = '';
		this.contact = '';
		this.zipcode = '';
		this.emailAddress = '';
		this.businessStatus = '';
		this.count = 0;
		this.objectionReasonName = '';
		this.inDebtCollection = false;
		
	}
	getProperties(){
		return DebtCollectionDtoModel.classProperties;
	}
}

